import request from '@/services/interceptor.js'

export const get_tipiIncasso = () => {
    return request({
        url: '/tipoincasso',
        method: 'get',
        loadingBar: true
    })
}

export const get_tipoIncasso = (id) => {
    return request({
        url: `/tipoincasso/${id}`,
        method: 'get',
        loadingBar: true
    })
}

export const create_tipoIncasso = (par) => {
    return request({
        url: '/tipoincasso',
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const update_tipoIncasso = (id, par) => {
    return request({
        url: `/tipoincasso/${id}`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

export const duplica_tipoIncasso = (id) => {
    return request({
        url: `/tipoincasso/${id}/duplica`,
        method: 'post',
        loadingBar: true
    })
}

export const delete_tipoIncasso = (id) => {
    return request({
        url: `/tipoincasso/${id}`,
        method: 'delete',
        loadingBar: true
    })
}
